import React from 'react';

import HelpTooltip from '../HelpTooltip';
import { Container, StyledSwitch, Title } from './Switch.styles';

export interface SwitchProps {
  checked: boolean;
  onChange: () => void;
  title?: string;
  disabled?: boolean;
  helpText?: string;
  size?: any;
  alignTitle?: 'left' | 'right';
}

const Switch = ({ title, helpText, size = 'sm', alignTitle = 'right', checked, ...props }: SwitchProps) => {
  return (
    <Container>
      {/* checked must never be undefined: an undefined first render makes React treat the underlying checkbox as
          uncontrolled, and when the value arrives later the DOM checked state (which drives the knob position via
          CSS :checked) can stay desynced from NextUI's internal state */}
      <StyledSwitch initialChecked={!!checked} checked={!!checked} size={size} $alignTitle={alignTitle} {...props} />
      {title && <Title $alignTitle={alignTitle}>{title}</Title>}
      {helpText && <HelpTooltip $helpText={helpText} />}
    </Container>
  );
};

export default Switch;
